import { HttpUrlSchema, utf16Length, IsoTimestampSchema } from "./string-validation"
import { z } from "zod"

export const PatientFillSchema = z.object({
	id: z.uuid(), orderId: z.uuid(), reference: z.string(), sequence: z.number().int().nonnegative(),
	status: z.enum(["preparing", "on_hold", "shipped", "delivered", "needs_review"]),
	message: z.string().nullable(),
	pharmacy: z.string().nullable(),
	trackingNumber: z.string().nullable(), trackingCarrier: z.string().nullable(),
	trackingUrl: HttpUrlSchema.nullable(),
	sentToPharmacyAt: IsoTimestampSchema.nullable(), shippedAt: IsoTimestampSchema.nullable(), deliveredAt: IsoTimestampSchema.nullable(),
	createdAt: IsoTimestampSchema,
})

export type PatientFill = z.infer<typeof PatientFillSchema>

export const PortalFillSchema = PatientFillSchema.extend({
 paymentStatus: z.string().nullable(),
	genHealthOrderId: z.string().nullable(), genHealthPrescriptionId: z.string().nullable(), onlyScriptsPrescriptionId: z.string().nullable(),
	remainingRefills: z.number().int().nonnegative().nullable(), membershipCycleId: z.uuid().nullable(),
	failureReason: z.string().nullable(), vendorStatus: z.string().nullable(),
	vendorSyncAttemptCount: z.number().int().nonnegative(),
	vendorSyncAction: z.string().nullable(), vendorSyncLastError: z.string().nullable(),
})

export const PatientRefillSchema = z.object({
 id: z.uuid(), orderId: z.uuid(), sequence: z.number().int().positive(), treatment: z.string(),
 paymentStatus: z.enum(["pending", "paid", "declined", "needs_review", "skipped", "cancelled"]),
 amountCents: z.number().int().nonnegative(), currency: z.string(), paymentDate: z.iso.date().nullable(),
 status: z.enum(["scheduled", "payment_received", "on_hold", "preparing", "on_hold", "shipped", "delivered", "needs_review", "skipped", "cancelled"]),
 message: z.string(), fill: PatientFillSchema.nullable(),
})
export type PatientRefill = z.infer<typeof PatientRefillSchema>
export const PortalRefillSchema = PatientRefillSchema.extend({
 patientId: z.uuid(), patientName: z.string(), fill: PortalFillSchema.nullable(),
 fulfillmentHoldReason: z.string().nullable(), paymentError: z.string().nullable(),
 cycleStartDate: z.iso.date().nullable(), cycleEndDate: z.iso.date().nullable(), skippedReason: z.string().nullable(),
})
export type PortalRefill = z.infer<typeof PortalRefillSchema>
export const FillHistoryEntrySchema = z.object({
 id: z.uuid(), status: z.string(), at: IsoTimestampSchema, vendorStatus: z.string().nullable(),
 failureReason: z.string().nullable(), trackingNumber: z.string().nullable(),
})
export const PatientRefillListSchema = z.object({ refills: z.array(PatientRefillSchema), hasMore: z.boolean() })
export const PortalRefillListSchema = z.object({ refills: z.array(PortalRefillSchema), hasMore: z.boolean() })
export const PortalRefillDetailSchema = z.object({ refill: PortalRefillSchema, history: z.array(FillHistoryEntrySchema) })
export const RefillListQuerySchema = z.object({
 orderId: z.uuid().optional(), status: z.enum(["needs_review", "on_hold", "preparing", "shipped", "delivered"]).optional(),
 search: z.string().trim().apply(utf16Length("max", 200)).optional(), offset: z.coerce.number().int().min(0).default(0),
})
